import React, { useState } from 'react';
import TravelStepper from './TravelStepper';
import './style.scss';
import TravelForm from './TravelForm';
import { withTranslation } from 'react-i18next';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';

const EditTravelDates = (props) => {
  const [activeStep, setActiveStep] = useState(1);
  const TOTAL_STEPS = 3;
  const steps = [
    { number: 1, title: props.t('TravelDetails'), descriptions: props.t('SteponeDescription') },
    { number: 2, title: props.t('Verification'), descriptions: props.t('StepTwoDescription') },
    { number: 3, title: props.t('Completion'), descriptions: props.t('StepThreeDescription') },
  ];

  // Calculate progress percentage
  const progress = ((activeStep - 1) / (TOTAL_STEPS - 1)) * 100;

  return (
    <div className="travelContainer">
      <div className="travelStepper">
        <TravelStepper activeStep={activeStep} t={props.t} steps={steps} />
      </div>
      <div className="form">
        <TravelForm
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          t={props.t}
          ExtensionLimitDetailsEndpoint={props?.fields?.ExtensionLimitDetailsEndpoint?.value}
          GenerateOTPEndpoint={props?.fields?.GenerateOTPEndpoint?.value}
          ExtraUserDetailsEndpoint={props?.fields?.ExtraUserDetailsEndpoint?.value}
          IsMockExtraUserDetailsEndpoint={props?.fields?.IsMockExtraUserDetailsEndpoint.value}
          IsMockGenerateOTPEndpoint={props?.fields?.IsMockGenerateOTPEndpoint?.value}
          GenerateOTPToken={props?.fields?.title?.value}
          EditDatesFormEndpoint={props?.fields?.EditDatesFormEndpoint?.value}
          IsMockVerifyOTPEndpoint={props?.fields?.IsMockVerifyOTPEndpoint.value}
          VerifyOTPEndpoint={props?.fields?.VerifyOTPEndpoint?.value}
          DeleteTripEndpoint={props?.fields?.DeleteTripEndpoint?.value}
          limitationNumber = {props?.fields?.limitationNumber?.value}
          limitationMessage = {props?.fields?.limitationMessage?.value}
          timeoutErrorMessage = {props?.fields?.timeoutErrorMessage?.value}
          verificationCodeExpiredErrorMessage = {props?.fields?.verificationCodeExpiredErrorMessage?.value}
          timeout = {props?.fields?.timeout?.value}
          otpVerificationCode = {props?.fields?.otpVerificationCode?.value}
          otpDidNotReceiveText = {props?.fields?.otpDidNotReceiveText?.value}
          otpSendNewCodeText = {props?.fields?.otpSendNewCodeText?.value}
        />
        <div className="MobileProgressBar">
          <div className="ProgressText">
            <span>{props.t('TotalProgress')}</span>
            <div>({Math.round(progress)}%)</div>
          </div>
          <div className="ProgressTrack">
            <div className="ProgressFill" style={{ width: `${progress}%` }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(withSitecoreContext()(EditTravelDates));
